import React from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

const Line = () => {
    return <div className={styles.line} />;
};

export default errorBoundary(Line);
